import React from 'react'

const ProductManagementTOSubcategory: React.FC = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="72" height="72" rx="14.5455" fill="url(#paint0_linear_4479_47345)" />
    <path
      d="M22.4754 29.9971C22.4754 30.1441 22.4754 30.2911 22.4754 30.3891C22.4754 35.6813 22.5244 41.0225 22.4754 46.3147C22.4754 48.1277 23.8965 49.4998 25.6605 49.4998C32.5698 49.4508 39.479 49.4998 46.3883 49.4998C48.2994 49.4998 49.5734 48.2257 49.5734 46.3147C49.5734 41.0225 49.5734 35.6813 49.5734 30.3891C49.5734 30.2421 49.5734 30.1441 49.5734 29.9971C40.4591 29.9971 31.4917 29.9971 22.4754 29.9971ZM41.9781 37.4943C41.9781 38.3274 41.2921 38.9644 40.5081 38.9644H31.4917C30.6587 38.9644 30.0217 38.2784 30.0217 37.4943C30.0217 36.6613 30.7077 36.0243 31.4917 36.0243H40.5081C41.2921 36.0243 41.9781 36.7103 41.9781 37.4943Z"
      fill="white"
    />
    <path
      d="M49.3285 28.4782H22.6715C21.7404 28.4782 20.9564 27.6942 20.9564 26.7632V24.2151C20.9564 23.284 21.7404 22.5 22.6715 22.5H49.3285C50.2595 22.5 51.0435 23.284 51.0435 24.2151V26.8122C50.9945 27.6942 50.2595 28.4782 49.3285 28.4782Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4479_47345"
        x1="35.5325"
        y1="2.5289e-06"
        x2="91.0286"
        y2="43.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6600E8" />
        <stop offset="1" stopColor="#BD0044" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProductManagementTOSubcategory
